import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingAnimationModule, UtilMessageModule } from '@summit/utils';

import { MaterialImportsModule } from './material.module';
import { AppRoutingModule } from 'app/routes/app.routing.module';

import { ForgotPasswordComponent } from 'app/components/forgot-password/forgot-password.component';
import { LoginComponent } from 'app/components/login/login.component';
import { ResetPasswordComponent } from 'app/components/reset-password/reset-password.component';
import { LoginSuspendedComponent } from 'app/components/login/login-suspended/login-suspended.component';
import { NotAuthorizedComponent } from 'app/components/not-authorized/not-authorized.component';
import { VerifyComponent } from 'app/components/verify/verify.component';
import {SessionExpiredComponent} from 'app/components/session-expired/session-expired.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialImportsModule,
    LoadingAnimationModule,
    MatPasswordStrengthModule.forRoot(),
    AppRoutingModule,
    UtilMessageModule
  ],
  declarations: [
    LoginComponent,
    VerifyComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoginSuspendedComponent,
    NotAuthorizedComponent,
    SessionExpiredComponent
  ],
  exports: [
    LoginComponent,
    VerifyComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoginSuspendedComponent,
    NotAuthorizedComponent,
    SessionExpiredComponent,
    MaterialImportsModule,
    LoadingAnimationModule,
    UtilMessageModule
  ]
})
export class AuthModule { }
